import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import ReactApexChart from "react-apexcharts";

ChartJS.register(ArcElement, Tooltip, Legend);

function renderDoughnut(chart) {
  const data = {
    labels: chart.legends.map((l) => l.name),
    datasets: [
      {
        data: chart.data.map((d) => d.value),
        backgroundColor: chart.data.map((d) => d.color),
        borderWidth: 0,
        hoverOffset: 4,
      },
    ],
  };
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "bottom", labels: { usePointStyle: true, padding: 20 } },
    },
    cutout: "70%",
  };
  return <Doughnut data={data} options={options} />;
}

function renderAreaChart(chart) {
  const series = chart.data.map((ds, idx) => ({
    name: chart.legends[idx]?.name || `Series ${idx + 1}`,
    data: ds.values.map((v) => v.value),
  }));
  const colors = chart.data.map((ds) => ds.startFillColor || "#008FFB");

  const options = {
    chart: { type: "area", toolbar: { show: false }, zoom: { enabled: false } },
    colors: colors,
    dataLabels: { enabled: false },
    stroke: { curve: "smooth", width: 2 },
    xaxis: {
      labels: { show: false },
      axisTicks: { show: false },
      axisBorder: { show: false },
    },
    yaxis: { labels: { style: { colors: "#A3AED0" } } },
    legend: { position: "bottom", markers: { radius: 12 } },
    fill: {
      type: "gradient",
      gradient: { shadeIntensity: 1, opacityFrom: 0.5, opacityTo: 0.1, stops: [0, 90, 100] },
    },
    grid: { show: true, borderColor: "#E2E8F0", strokeDashArray: 4 },
  };

  if (chart.yMin !== undefined) options.yaxis.min = chart.yMin;
  if (chart.yMax !== undefined) options.yaxis.max = chart.yMax;

  return <ReactApexChart options={options} series={series} type="area" height="100%" width="100%" />;
}

function renderBarChart(chart) {
  const categories = [];
  const series1 = [];
  const series2 = [];

  chart.data.forEach((item) => {
    if (item.label) {
      categories.push(item.label);
      series1.push(item.value);
    } else {
      series2.push(item.value);
    }
  });

  const series = [
    { name: "Significant Events", data: series1 },
    { name: "Critical Events", data: series2 },
  ];

  const options = {
    chart: { type: "bar", toolbar: { show: false } },
    colors: ["#177AD5", "#ED6665"],
    plotOptions: { bar: { columnWidth: "40%", borderRadius: 3 } },
    dataLabels: { enabled: false },
    xaxis: {
      categories: categories,
      labels: { style: { colors: "#A3AED0" } },
      axisBorder: { show: false },
    },
    yaxis: { labels: { style: { colors: "#A3AED0" } } },
    legend: { position: "bottom", markers: { radius: 12 } },
    grid: { show: true, borderColor: "#E2E8F0", strokeDashArray: 4 },
  };

  return <ReactApexChart options={options} series={series} type="bar" height="100%" width="100%" />;
}

export function renderLiveChart(chart) {
  if (chart.type === "doughnut") return renderDoughnut(chart);
  if (chart.type === "areachart") return renderAreaChart(chart);
  if (chart.type === "barchart") return renderBarChart(chart);
  return null;
}
